import Vue from 'vue';
import Component from 'vue-class-component';
import  SWP, { SwiperOptions } from 'swiper';
import 'swiper/dist/js/swiper.min.js';
import { Prop, Model, Watch } from 'vue-property-decorator';

type Swiper = SWP
declare let Swiper: typeof SWP

@Component({
})
export default class Slider extends Vue {
    @Prop() breakpoints!: SwiperOptions['breakpoints']
    @Prop({ default: 1 }) slidesPerView!: number | string
    @Prop({ default: false }) pag!: boolean | string
    @Prop({ default: false }) nav!: boolean | string
    @Prop({ default: false }) scrollbar!: boolean | string
    @Prop({ default: 0 }) spaceBetween!: number
    @Prop({ default: 0, type: Number }) autoplay!: number
    @Prop({ default: true, type: Boolean }) disableOnInteraction!: boolean
    @Model('update', { type: Number, default: 0 }) slide!: number
    swiper: Swiper | undefined = undefined
    el: HTMLElement | undefined = undefined

    @Watch('slide') onCurrentSlideChanged(val: number) {
        if (this.swiper) this.swiper.slideTo(val)
    }
    mounted() {
        this.el = this.$el.querySelector('.swiper-container') as HTMLElement;
        let opts: SwiperOptions = {
            slidesPerView: this.slidesPerView ? +this.slidesPerView : 1,
            spaceBetween: +this.spaceBetween,
            autoplay: this.autoplay ? {
                delay: this.autoplay,
                disableOnInteraction: this.disableOnInteraction
            } : false
        }
        if (this.pag || typeof this.pag === 'string') opts.pagination = {
            el: this.$el.querySelector('.swiper-pagination') as HTMLElement,
        }
        if (this.nav || typeof this.nav === 'string') opts.navigation = {
            nextEl: this.$el.querySelector('.swiper-button-next') as HTMLElement,
            prevEl: this.$el.querySelector('.swiper-button-prev') as HTMLElement,
        }
        if (this.scrollbar || typeof this.scrollbar === 'string') opts.scrollbar = {
            el: this.$el.querySelector('.swiper-scrollbar') as HTMLElement,
        }
        if (this.breakpoints || typeof this.breakpoints === 'object') opts.breakpoints = this.breakpoints
        this.swiper = new Swiper(this.el, opts)

        this.swiper.on('slideChange', () => {
            this.$emit('update:slide', (this.swiper as Swiper).realIndex)
        })
    }
    updated() {
        if (this.swiper) this.swiper.update();
    }
}